import { Loadable } from 'foundations-components/transitional/utils/Loadable';
import { MeetingFollowUpPopoverContentLoadingState } from './MeetingFollowUpPopoverContentLoadingState';
export const MeetingFollowUpPopoverContentAsync = Loadable({
  loader: () => import( /* webpackChunkName: "meeting-follow-up-popover-content" */'./MeetingFollowUpPopoverContent').then(module => module.MeetingFollowUpPopoverContent),
  LoadingComponent: MeetingFollowUpPopoverContentLoadingState,
  ErrorComponent: () => null
});